import Vue from 'vue';
import { categoryStore } from '@/store';

export const adSenseLogic = Vue.extend({
    data() {
        return {
            defaultIndex: 1,
            categoryState: categoryStore.state,
        };
    },
    mounted() {
        if (
            this.adSenseIndex === this.index &&
            window['__host__']['enable_adsense_widget']
        ) {
            this.callGoogleContentAds();
        }
    },
    computed: {
        adSenseIndex() {
            if (this.isVeganDomain()) return 0;
            let index = this.defaultIndex;
            if (
                window['__dyanmic_template_props__'] &&
                (window['__dyanmic_template_props__']['CategoryPage'][
                    'googleAdsenseWidgetPositionMobile'
                ] ||
                    window['__dyanmic_template_props__']['CategoryPage'][
                        'googleAdsenseWidgetPositionDesktop'
                    ])
            ) {
                index = this.isMobile()
                    ? window['__dyanmic_template_props__']['CategoryPage'][
                          'googleAdsenseWidgetPositionMobile'
                      ]
                    : window['__dyanmic_template_props__']['CategoryPage'][
                          'googleAdsenseWidgetPositionDesktop'
                      ];
            }
            return index;
        },
        showGoogleAdsWidget() {
            const host = window['__host__'];
            if (!host['hide_adsense_widget']) return true;
            if (!host['hide_adsense_widget_categories']) return true;
            return !host['hide_adsense_widget_categories'].includes(
                this.categoryState.category.id
            );
        },
        getGoogleAdWidgetId() {
            if (!window['adSenseOptions']) return '';
            return 'content-related-search-widget';
        },
    },
    methods: {
        isVeganDomain() {
            return 'vegan.top5-bestmealdelivery.com' === window.location.host;
        },
        injectGoogleAdUnitElements(data) {
            if (!data) return;
            if (!window['__host__']['adsense_pub_id']) return;
            if (data['content'].search('<ins') <= 0) return;

            setTimeout(() => {
                const script = document.createElement('script');
                const clientId = window['__host__']['adsense_pub_id'].replace(
                    'partner',
                    'ca'
                );
                script.src =
                    'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=' +
                    clientId;
                script.crossOrigin = 'anonymous';
                document.head.appendChild(script);
                try {
                    (window['adsbygoogle'] = window['adsbygoogle'] || []).push(
                        {}
                    );
                } catch (e) {
                    console.log(e);
                }
            }, 1000);
        },
        injectGoogleAdsElement(data) {
            if (!data) return data;

            if (!window['__host__']['enable_adsense_widget']) return data;

            const options = window['adSenseOptions'];
            if (!options) return data;
            const adsenseBoxCount =
                data['content'].split('adsense_box').length - 1;

            if (adsenseBoxCount <= 0) {
                // inject adsense_box after cta
                setTimeout(() => {
                    const elems = document.getElementsByClassName('btn');
                    if (!elems && elems.length == 0) return;
                    if (!elems[0]) return;
                    const elem = elems[0].parentElement;
                    const adsDiv = document.createElement('div');
                    adsDiv.id = this.getGoogleAdWidgetId;
                    elem.insertAdjacentElement('afterend', adsDiv);
                    this.callGoogleContentAds(
                        false,
                        null,
                        data['adsense_keywords']
                    );
                }, 1000);

                data['content'] = data['content'].replace(
                    '[adsense_read_more]',
                    ''
                );
                return data;
            }

            for (let i = 0; i < adsenseBoxCount; i++) {
                data['content'] = data['content'].replace(
                    '[adsense_box]',
                    `<div id="${this.getGoogleAdWidgetId + '_' + i}"></div>`
                );
            }

            data['content'] = data['content'].replace(
                '[adsense_read_more]',
                ''
            );

            setTimeout(() => {
                this.callGoogleContentAds(
                    false,
                    adsenseBoxCount,
                    data['adsense_keywords']
                );
            }, 1000);

            return data;
        },
        googleAdLoadedCallback(
            containerName,
            adsLoaded,
            isExperimentVariant,
            callbackOptions
        ) {
            if (!window['track']) return;

            if (!adsLoaded) {
                window['track'].event({
                    event: 'Error: Related Keywords Widget',
                });
                return;
            }

            window['track'].event({
                event: 'Impression: Related Keywords Widget',
            });

            if (!callbackOptions && !callbackOptions['termPositions']) return;

            for (const term in callbackOptions['termPositions']) {
                window['track'].event({
                    event: 'Terms: Related Keywords Widget',
                    position: callbackOptions['termPositions'][term],
                    term: term,
                });
            }
        },
        callGoogleContentAds(
            partnerRow = true,
            numberOfWidget = null,
            terms = null
        ) {
            const host = window['__host__'];

            if (!host['enable_adsense_widget']) return;

            if (partnerRow === true && !this.showGoogleAdsWidget) return;

            const options = window['adSenseOptions'];
            if (!options) return;

            if (partnerRow === true) {
                terms =
                    this.categoryState.category['adsense_keywords'] ??
                    host['adsense_keywords'];
            } else {
                terms = terms ?? host['adsense_keywords'];
            }

            const pageOptions = {
                pubId: options.pubId,
                styleId: options.styleId,
                relatedSearchTargeting: 'content',
                adtest: 'off',
                query: window['adsense_query'],
                channel: window['adsense_channel_id'],
                resultsPageBaseUrl: options.resultsPageBaseUrl,
                resultsPageQueryParam: options.resultsPageQueryParam,
                referrerAdCreative: options['referrerAdCreative'] || null,
            };

            const widgets = [];
            terms = window['adsense_query'] ? '' : terms || '';

            if (numberOfWidget === null) {
                widgets.push({
                    container: this.getGoogleAdWidgetId,
                    relatedSearches: 6,
                    terms: terms,
                    adLoadedCallback: this.googleAdLoadedCallback,
                });
            } else {
                for (let i = 0; i < numberOfWidget; i++) {
                    widgets.push({
                        container: this.getGoogleAdWidgetId + '_' + i,
                        relatedSearches: 6,
                        terms: terms,
                        adLoadedCallback:
                            i === 0 ? this.googleAdLoadedCallback : null,
                    });
                }
            }

            window['_googCsa']('relatedsearch', pageOptions, ...widgets);
        },
    },
});
